import React, {PureComponent} from 'react';
import {Field,FieldArray} from 'redux-form'
import {Icon, Input, Form, Button, Row} from 'antd';
import {RTLCol} from '../RTLKit';


let id = 0;

const renderField = ({input, label, type, meta: {touched, error}}) => {

    let defaultValue = null;
    if(input.value)
        defaultValue = input.value.txt

    return(
        <div>
            <Input
                {...input}
                label={label}
                value={defaultValue}
            />

        </div>
    )
}

const renderAddress = ({fields, meta: {error}}) => {
    return(
        <div className = "addAddress">
            <Button type="dashed" block type="button" onClick={() => fields.push()}>
                اضافه کردن آدرس
                <Icon type="plus"/>
            </Button>

            {fields.map((addresses, index) =>{

                return(
                    <Row type="flex" align="top" key={index}>
                        <RTLCol span={21} className="right">
                            <Form.Item key={index}>
                                <Input
                                    name={addresses}
                                    type="text"
                                    component={renderField}
                                />
                            </Form.Item>
                        </RTLCol>
                        <RTLCol span={3}>
                            <Button type="dashed" onClick={() => fields.remove(index)} className="left minusBtn">
                                <Icon type="minus"/>
                            </Button>
                        </RTLCol>
                    </Row>
                )})}
            {error && <div className="error">{error}</div>}
        </div>
    )
}

export default class DynamicFieldSet extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        const {
            input,
            label,
            type,
            meta: {touched, error, warning},
        } = this.props;

        return (
            <div>
                <RTLCol className="formLabel" md={label ? 5 : 0} sm={24}>
                    {label ? <label>{label} : </label> : null}
                </RTLCol>
                <RTLCol md={label ? 15 : 19} sm={24}>
                    <FieldArray
                        name = "addresses"
                        component={renderAddress}
                        className="ant-input"
                        placeholder={label}
                        type="text"
                    />
                </RTLCol>
            </div>

        );
    }
}
